import { Add, Upload } from '@mui/icons-material'
import { Menu, MenuItem } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { ReactElement, useState } from 'react'
import { I18n } from 'src/i18n'
import {
  ADD_PROMPT,
  AddToListStage,
  useAddToListStore,
} from 'src/store/lists/AddToListStore'
import { defaultTheme } from 'src/theme'
import styled from 'styled-components'
import { useListsStore } from '../../../../store/lists/ListsStore'
import { SELLER_MANAGED_LIST_LABEL } from '../interfaces'
import { useUserStore } from '../../../../store/user/UserStore'

const AddMenu = observer((): ReactElement => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
  const openMenu = Boolean(menuAnchorEl)

  const listStore = useListsStore()
  const addToListStore = useAddToListStore()
  const userStore = useUserStore()

  const parentOrgId = userStore?.preferences?.parentOrgId
  const isAdmin = Number(parentOrgId) === 0

  const isUserAuthorized =
    listStore.selectedCategory?.value !== SELLER_MANAGED_LIST_LABEL || isAdmin

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!isUserAuthorized) return

    setMenuAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setMenuAnchorEl(null)
  }

  const handleImportFile = (): void => {
    addToListStore.setStage(AddToListStage.ADD_PROMPT)
    addToListStore.setSelectedPrompt(ADD_PROMPT.IMPORT_FILE)
  }

  const handleAddManually = (): void => {
    addToListStore.setStage(AddToListStage.ADD_PROMPT)
    addToListStore.setSelectedPrompt(ADD_PROMPT.MANUAL)
  }

  return (
    <Wrapper>
      <Title onClick={handleMenuClick} disabled={!isUserAuthorized}>
        <StyledAddIcon /> <I18n name="addItems" />
      </Title>
      <StyledMenu
        anchorEl={menuAnchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        style={{ marginTop: '42px' }}
      >
        <Items>
          <Item onClick={handleAddManually}>
            <Add style={{ color: defaultTheme.colors.greyLight }} />
            <I18n name="addManually" />
          </Item>
          <Item onClick={handleImportFile}>
            <Upload style={{ color: defaultTheme.colors.greyLight }} />
            <I18n name="importFile" />
          </Item>
        </Items>
      </StyledMenu>
    </Wrapper>
  )
})

const Wrapper = styled.div`
  width: 147px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Title = styled.div<{ disabled: boolean }>`
  font-family: Oswald, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  color: ${(p) =>
    p.disabled
      ? defaultTheme.colors.disabledButton
      : defaultTheme.colors.black};
  user-select: none;
  width: 100%;
  text-align: center;
  cursor: pointer;
`

const StyledMenu = styled(Menu)``

const Items = styled.div`
  width: 217px;
  padding: 0px 10px 0px 10px;
`

const Item = styled(MenuItem)`
  display: flex;
  gap: 0.3rem;
  text-transform: Capitalize;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
`

const StyledAddIcon = styled(Add)`
  margin-top: -3px;
`

export default AddMenu
